import { createSelector } from 'reselect';
import { HELP_DESK_ROUTING_CONFIG_EDIT } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const getHasHelpDeskRoutingConfigEditAccess = createSelector([getScopes], scopes => scopes.includes(HELP_DESK_ROUTING_CONFIG_EDIT));